module.exports = __webpack_public_path__ + "img/check_on.128fa77c.svg";